import Vue from 'vue'
import App from './App.vue'
import router from '../router'
import bootstrap from 'bootstrap-vue'
import axios from 'axios'
import Vuelidate from 'vuelidate'

Vue.config.productionTip = false
Vue.use(bootstrap);
Vue.use(Vuelidate);
Vue.component(Vuelidate);

Vue.mixin({
  methods: {
    validate() {
      this.$v.$touch();
      let isValid = !this.$v.$invalid;
      this.$emit('on-validate', this.$data, isValid);
      return isValid;
    },
    loadActiveDates(){
      axios.get("/booking/GetBranchServiceDates/b5da9a5f6f3ee03481ec9b1bb62816cc05ed38891324beb4506085e6daac88d5/47fc5d019830fe7e5a4696f145ec29e32ae8162e4015e2711db748021e3cb3a2")
          .then((r) => {
            console.log(r.data)
            return r.data;
          })
          .catch((e) => {
            console.log(e)

          })
      return null;
    }
    
  },
})

// const MyPlugin = {
//   install(Vue) {
//     Vue.prototype.validate = () => {
//       this.$v.form.$touch();
//       let isValid = !this.$v.form.$invalid;
//       this.$emit('on-validate', this.$data, isValid);
//       return isValid;
//     }
//   },
// }
// Vue.use(MyPlugin)


Vue.prototype.$http = axios;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
